import { useI18nSubscription } from '../../i18n/useI18nSubscription.js';
import { i18n } from '../../../i18n/index.js';
import type { ReactElement } from 'react';
import { Switch, Tooltip } from 'antd';

interface AutoApproveToggleProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
}

export function AutoApproveToggle({
  checked,
  disabled = false,
  onChange,
}: AutoApproveToggleProps): ReactElement {
  useI18nSubscription();
  return (
    <Tooltip title={i18n.t('crm.ai_chat.auto_approve.tooltip')}>
      <span className="flex shrink-0 items-center gap-1.5 text-xs text-stone-500">
        <Switch
          size="small"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          aria-label={i18n.t('crm.ai_chat.auto_approve.label')}
          data-testid="auto-approve-toggle"
        />
        <span className="hidden lg:inline">{i18n.t('crm.ai_chat.auto_approve.label')}</span>
      </span>
    </Tooltip>
  );
}
